import { render } from "./Profil.vue?vue&type=template&id=5dff5769"
import script from "./Profil.vue?vue&type=script&lang=js"
export * from "./Profil.vue?vue&type=script&lang=js"
script.render = render

export default script